"use strict";
/**
 * FinEdge Retirement Calculator — engine types.
 *
 * Pure, deterministic types for the retirement calculation engine.
 * No React, no DB, no browser storage. All rates are decimals
 * (0.10 = 10%). All money is INR full rupees (no rounding inside
 * the engine — display rounding only at the UI edge).
 *
 * Convention snapshot (locked, see Phase-2 approval memo):
 *   - SIP contribution timing: END of month.
 *   - Withdrawal timing:       BEGINNING of month.
 *   - Annual return → monthly: (1 + r) ^ (1/12) − 1  (NOT r/12).
 *   - Step-up applies after each 12 completed contributions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
